import React from 'react';

export const getSelectLabel = label => ({
  label: <div className="select-label">{label}</div>,
  value: 'label',
  isDisabled: true
});

export const getSelectedOption = (options, value) => options.find(option => option.value === value);
